import React from 'react'
import "../datatable/DataTable.css";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import CustomizedMenus from '../customizedmenu/CustomizedMenu';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import EmailIcon from '@mui/icons-material/Email';
import { EmailContent } from '../emailcontent/EmailContent';
import { DownloadContent } from '../emailcontent/EmailContent';

const DataTable = (props) => {

  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(25);

  const handleNewClick = () => {
    if(props.modulename == "Situations"){
        props.setEditorState({ open: true, data: {Id: null, ImageUrl: '//assets//situations//52E784DA-B4E4-47CB-BE16-34DF6CCBD35C.png'}});
    }
    else if(props.modulename == "Companies"){
      props.setEditorState({ open: true, data: {Id: null, Logo: '//assets//companies//52E784DA-B4E4-47CB-BE16-34DF6CCBD35C.png'}});
  }
  else if(props.modulename == "Users"){
    props.setEditorState({ open: true, data: {Id: null, Photo: '//assets//users//52E784DA-B4E4-47CB-BE16-34DF6CCBD35C.png'}});
}
    else{
      props.setEditorState({ open: true, data: {Id: null}});
    }
  };

  const handleSelectedDownloads =()=>{
    if(selectedRows.length == 0){
      confirmAlert({
        title: 'No recrod selected',
        message: 'Please select at least one record',
        buttons: [
          {
            label: 'Ok'
          }
        ]
      });
    }
    else{
      axios.post('/userassessments/downloadselectedreports', selectedRows)
      .then(function (response) {
        const url = axios.defaults.baseURL + '/' + response.data;
        const link = document.createElement('a');
        link.href = url;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
      })
      .catch(function (error) {
        console.error(error);
      });
    }
  }

  const handleDeleteClick =()=>{
    if(selectedRows.length == 0){
      confirmAlert({
        title: 'No recrod selected',
        message: 'Please select at least one record',
        buttons: [
          {
            label: 'Ok'
          }
        ]
      });
    }
    else{
        confirmAlert({
          title: 'Delete Confirmation',
          message: 'Are you sure to delete these records?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                axios.post('/' + props.modulename + '/bulkdelete', selectedRows)
                .then(function (response) {
                  
                  props.setPageState({loading: false});
                })
                .catch(function (error) {
                  console.error(error);
                });
              }
            },
            {
              label: 'No',
              className: 'btn btn-primary'
            }
          ]
        });
    }
  }

  const handleDownloadTrainingTextClick =()=>{
    if(selectedRows.length == 0){
      confirmAlert({
        title: 'No recrod selected',
        message: 'Please select at least one record',
        buttons: [
          {
            label: 'Ok'
          }
        ]
      });
    }
    else{
      axios.post('/' + props.modulename + '/bulktext', selectedRows)
      .then(function (response) {
        const element = document.createElement("a");
        const file = new Blob(response.data.data, {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = "Training.txt";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
      })
      .catch(function (error) {
        console.error(error);
      });
    }
  }

  const handleNotificationClick =()=>{
    if(selectedRows.length == 0){
      confirmAlert({
        title: 'No recrod selected',
        message: 'Please select at least one record',
        buttons: [
          {
            label: 'Ok'
          }
        ]
      });
    }
    else{

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert">
              <div className="react-confirm-alert-body custom-ui">
                <h1>Email verification</h1>
                Please verify the email content.
                <EmailContent id="js-selected-records"/>
                <div className="react-confirm-alert-button-group">
                  <button onClick={onClose}>No</button>
                  <button className="btn btn-primary"
                    onClick={() => {
                      const c = document.getElementById("js-selected-records").innerHTML;
                      setEmailContent(c);
                      onClose();
                      axios.post('/' + props.modulename + '/SendNotification', {Rows: selectedRows, Content : c, All: false})
                      .then(function (response) {
                        confirmAlert({
                          title: 'Email Notification Sent',
                          message: 'Selected users have been sent notifications to take assessments',
                          buttons: [
                            {
                              label: 'Ok',
                              onClick: () => {
                                props.setPageState({loading: false});
                              }
                            }
                          ]
                        });
                      })
                      .catch(function (error) {
                        onClose();
                        console.error(error);
                      });
                      
                    }}
                  >
                    Yes, Send email!
                  </button>
                </div>
              </div>
            </div>
          );
        }
      });
      
    }
  }

  const handleSendAssessmentToAll=()=>{
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert">
            <div className="react-confirm-alert-body custom-ui">
              <h1>Email verification</h1>
              Please verify the email content.
              <EmailContent id="js-selected-records" />
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button className="btn btn-primary"
                  onClick={() => {
                    const c = document.getElementById("js-selected-records").innerHTML;
                    setEmailContent(c);
                    onClose();
                    axios.post('/' + props.modulename + '/SendNotification', {Rows: [], Content : c, All: true})
                    .then(function (response) {
                      confirmAlert({
                        title: 'Email Notification Sent',
                        message: 'All employees have been sent notifications to take assessments',
                        buttons: [
                          {
                            label: 'Ok',
                            onClick: () => {
                              props.setPageState({loading: false});
                            }
                          }
                        ]
                      });
                    })
                    .catch(function (error) {
                      onClose();
                      console.error(error);
                    });
                    
                  }}
                >
                  Yes, Send email!
                </button>
              </div>
            </div>
          </div>
        );
      }
    });
  }

  const handleEmailClick =()=>{
    if(selectedRows.length == 0){
      confirmAlert({
        title: 'No recrod selected',
        message: 'Please select at least one record',
        buttons: [
          {
            label: 'Ok'
          }
        ]
      });
    }
    else{
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert">
              <div className="react-confirm-alert-body custom-ui">
                <h1>Email verification</h1>
                Please verify the email content.
                <DownloadContent id="js-selected-records"/>
                <div className="react-confirm-alert-button-group">
                  <button onClick={onClose}>No</button>
                  <button className="btn btn-primary"
                    onClick={() => {
                      const c = document.getElementById("js-selected-records").innerHTML;
                      setEmailContent(c);
                      onClose();
                      axios.post('/userassessments/SendNotification', {Rows: selectedRows, Content : c, All: false})
                      .then(function (response) {
                        confirmAlert({
                          title: 'Reports emailed',
                          message: 'Selected users have been sent notifications to download their report',
                          buttons: [
                            {
                              label: 'Ok',
                              onClick: () => {
                                props.setPageState({loading: false});
                              }
                            }
                          ]
                        });
                      })
                      .catch(function (error) {
                        onClose();
                        console.error(error);
                      });
                      
                    }}
                  >
                    Yes, Send email!
                  </button>
                </div>
              </div>
            </div>
          );
        }
      });





    }
  }

  const handleResendAssessmentClick=()=>{
    if(selectedRows.length == 0){
      confirmAlert({
        title: 'No recrod selected',
        message: 'Please select at least one record',
        buttons: [
          {
            label: 'Ok'
          }
        ]
      });
    }
    else{

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert">
              <div className="react-confirm-alert-body custom-ui">
                <h1>Email verification</h1>
                Please verify the email content.
                <EmailContent id="js-selected-records"/>
                <div className="react-confirm-alert-button-group">
                  <button onClick={onClose}>No</button>
                  <button className="btn btn-primary"
                    onClick={() => {
                      const c = document.getElementById("js-selected-records").innerHTML;
                      setEmailContent(c);
                      onClose();
                      axios.post('/userassessments/ReSendNotification', {Rows: selectedRows, Content : c, All: false})
                      .then(function (response) {
                        confirmAlert({
                          title: 'Email Notification Sent',
                          message: 'Selected assessments have been re-sent',
                          buttons: [
                            {
                              label: 'Ok',
                              onClick: () => {
                                props.setPageState({loading: false});
                              }
                            }
                          ]
                        });
                      })
                      .catch(function (error) {
                        onClose();
                        console.error(error);
                      });
                      
                    }}
                  >
                    Yes, Send email!
                  </button>
                </div>
              </div>
            </div>
          );
        }
      });
      
    }
  }

  const handleGroupReportClick =()=>{
    if(selectedRows.length == 0){
      confirmAlert({
        title: 'No recrod selected',
        message: 'Please select at least one record',
        buttons: [
          {
            label: 'Ok'
          }
        ]
      });
    }
    else{
      console.log(selectedRows);
      axios({
        url: '/userassessments/generategroupreport',
        method: 'POST',
        data: selectedRows
      }).then((response) => {
        const url = axios.defaults.baseURL + '/' + response.data.url;
        const link = document.createElement('a');
        link.href = url;
        link.target = "_blank";
        document.body.appendChild(link);
      link.click();
      }).catch(function (error) {
        console.error(error);
      });
    }
  }

  const handleImportCompanies =()=>{
    confirmAlert({
      customUI: ({ onClose }) => {
        const whenFileChanged=(e)=>{
            onClose();
            uploadFileToServer(e.target.files[0], '/companies/import');
        }
        return (
          <div className='react-confirm-alert-body'>
            <h1>Import Companies</h1>
            <input type="file" onChange={whenFileChanged} id="import-excel"></input>
            <p>Only .xlxs files are supported</p>
            <hr/>
            <button className="btn btn-outline-secondary"
              onClick={() => {
                onClose();
              }}>Close</button>
          </div>
        );
      }
    });
  }

  const handleImportUsers=()=>{
    confirmAlert({
      customUI: ({ onClose }) => {

        const whenFileChanged=(e)=>{
            onClose();
            uploadFileToServer(e.target.files[0], '/users/import');
        }

        return (
          <div className='react-confirm-alert-body'>
            <h1>Import Users</h1>
            <input type="file" onChange={whenFileChanged} id="import-excel" className="upload-file"></input>
            <p>Only .xlxs files are supported</p>
            <hr/>
            <button className="btn btn-outline-secondary"
              onClick={() => {
                onClose();
              }}>Close</button>
          </div>
        );
      }
    });
  }

  const handleImportSituations=()=>{
    confirmAlert({
      customUI: ({ onClose }) => {

        const whenFileChanged=(e)=>{
            onClose();
            uploadFileToServer(e.target.files[0], '/situations/import');
        }

        return (
          <div className='react-confirm-alert-body'>
            <h1>Import Situations</h1>
            <input type="file" onChange={whenFileChanged} id="import-excel" className="upload-file"></input>
            <p>Only .xlxs files are supported</p>
            <hr/>
            <button className="btn btn-outline-secondary"
              onClick={() => {
                onClose();
              }}>Close</button>
          </div>
        );
      }
    });
  }


  const [emailContent, setEmailContent] = useState("");
  const [downloadContent, setDownloadContent] = useState("");

  const handleDownloadAll=()=>{
    axios({
      url: '/userassessments/downloadallreports',
      method: 'GET'
    }).then((response) => {
      const url = axios.defaults.baseURL + '/' + response.data;
      const link = document.createElement('a');
      link.href = url;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
    }).catch(function (error) {
      console.error(error);
    });
  }

  

  const uploadFileToServer=(file, path)=>{
    if(file){
      const formData = new FormData();
      formData.append('formFile', file);
      axios.post(path, formData,{
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then(function (response) {
        if(response.data.status == "success"){
          if(response.data.message != ""){
            props.setErrors(response.data.message);
          }
          else{
            props.setPageState({loading: false});
          }
        }
        else{
          props.setErrors(response.data.message);
        }
      })
      .catch(function (response) {
        props.setErrors(response.data.message);
      });
    }
  }



  const applySearch=(e)=>{
    if(e.target.value.length > 2 || e.keyCode == 8 || e.keyCode == 13){
      props.setSearch(e.target.value);
      props.setPageState({loading: false});
    }
  }

  const applyManagerSelection=(e)=>{
    props.setManagerType(e.target.value);
      props.setPageState({loading: false});
  }

  const applyGenderSelection=(e)=>{
    props.setGender(e.target.value);
      props.setPageState({loading: false});
  }

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <div className="searchbar">
        {props.modulename != "Behaviors" && props.modulename != "Behavioral Clusters" && 
            <input type="text" className="form-control" placeholder="search for..." onKeyUp={(e)=>applySearch(e)}/>
          }
        {props.modulename == "Users" ? 
          <select className="form-control" onChange={(e)=>{ applyGenderSelection(e);}}>
          <option value={0}>All</option>
          <option value={1}>Male</option>
          <option value={2}>Female</option>
          <option value={3}>Other</option>
          <option value={4}>Prefer not to disclose</option>
        </select>
        : ""}

        {props.modulename == "Situations" || props.modulename == "Users" ||  props.modulename == "Assessments" ?
        <select className="form-control" onChange={(e)=>{ applyManagerSelection(e);}}>
          <option value={0}>All</option>
          <option value={1}>First Time Manager (FTM)</option>
          <option value={2}>Middle Manager (MM)</option>
          <option value={3}>Others (OTR)</option>
        </select>
      : ""  
      }
      </div>
        <div className="toolbar">
        {props.modulename == "Assessments" ?
          <a href="javascript:void(0);" className="btn btn-outline-primary" onClick={handleDownloadAll}><DownloadForOfflineIcon/> Download All</a>
        : ""  
        }
          {props.modulename != "Behaviors" && props.modulename != "Behavioral Clusters" && props.modulename != "Assessments" && props.modulename != "Training" &&
            <a className="link" onClick={handleNewClick}>+ Add New</a>
          }
          {/* {props.modulename == "Users" ?
          <a href="javascript:void(0);" className="btn btn-outline-primary" onClick={handleSendAssessmentToAll}><EmailIcon/> Send Assessment to All</a>
        : ""  
        } */}
          {props.modulename != "Behaviors" && props.modulename != "Behavioral Clusters" ? 
            <CustomizedMenus modulename={props.modulename} handleDeleteClick={handleDeleteClick} handleNotificationClick={handleNotificationClick} 
            handleEmailClick={handleEmailClick} handleGroupReportClick={handleGroupReportClick} 
            handleImportCompanies={handleImportCompanies} handleImportUsers={handleImportUsers}  handleImportSituations={handleImportSituations} handleSelectedDownloads={handleSelectedDownloads}
            handleResendAssessmentClick={handleResendAssessmentClick} handleSendAssessmentToAll={handleSendAssessmentToAll} handleDownloadTrainingTextClick={handleDownloadTrainingTextClick}
            /> : ""
          }
        </div>
      </div>
      <DataGrid
        getRowId={(row) => row.Id}
        className="datagrid"
        rows={props.rows}
        columns={props.columns}
        // pageSize={8}
        // rowsPerPageOptions={[8]}

        pageSize={pageSize}
        onPageSizeChange={(newPage) => setPageSize(newPage)}
        pagination
        checkboxSelection={props.checkboxSelection}
        disableColumnFilter
        disableColumnMenu 
        onSelectionModelChange={(ids) => {
          // const selectedIDs = new Set(ids);
          // const selectedRowData = props.rows.filter((row) =>
          //   selectedIDs.has(row.id.toString())
          // );
          setSelectedRows(ids);
        }}
        sx={{
          '.MuiDataGrid-columnSeparator': {
            display: 'none',
          },
        }}
      />

      
    </div>
  );
};

export default DataTable;